import { Link } from 'react-router-dom'
import { TopBar } from '../components/TopBar'
import { Avatar, roleLabels } from '../components/Avatar'
import { useApp } from '../store/AppContext'
import { localISODate } from '../lib/date'
import { adultAlexProfessionalTeam } from '../lib/adultAlexScope'

const todayISO = localISODate()

export function Team() {
  const { allUsers, currentUser, isAvailableOn } = useApp()
  const adultProfile = currentUser.id === 'u-alex' || currentUser.id === 'u-mark'
  const connectedName = currentUser.id === 'u-mark' ? 'Alex’s Team' : 'My Team'

  const teamMembers = adultAlexProfessionalTeam(allUsers)

  return (
    <div className={adultProfile ? 'min-h-screen bg-[#f5f8fb] text-slate-900' : ''}>
      <TopBar title={connectedName} subtitle={currentUser.id === 'u-mark' ? 'People supporting Alex' : 'People connected to your support'} />

      <div className="flex flex-col gap-3 px-3.5 py-4">
        {adultProfile && (
          <div className="rounded-[22px] border border-[#dbe6ef] bg-gradient-to-r from-[#173f82] via-[#245da8] to-[#3374bc] p-4 text-white shadow-[0_8px_24px_rgba(36,79,132,.10)]">
            <p className="text-[10px] font-black uppercase tracking-[.12em] text-blue-100">Adult support circle</p>
            <p className="mt-1 text-sm font-black">{currentUser.id === 'u-mark' ? 'Alex Turner’s connected team' : 'Your connected support team'}</p>
            <p className="mt-1 text-[11px] font-semibold leading-5 text-blue-100">Only allied-health professionals and support workers connected to Alex are shown here. Child-profile teams are kept separate.</p>
          </div>
        )}

        <Link to="/onboarding" className={adultProfile ? 'rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_5px_18px_rgba(15,23,42,.05)]' : 'rounded-2xl border border-brand-100 bg-brand-50 p-4 shadow-card'}>
          <div className="flex items-center gap-3">
            <div className={adultProfile ? 'flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] bg-[#e8f7f5] text-[#249a96]' : 'flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white text-2xl shadow-sm'}>✓</div>
            <div className="min-w-0 flex-1"><p className="text-sm font-black text-slate-900">Team onboarding</p><p className="mt-1 text-[11px] font-semibold leading-5 text-slate-500">Training, documents and participant-specific information for this support circle.</p></div>
            <span className={adultProfile ? 'text-[#245a9d]' : 'text-brand-600'}>→</span>
          </div>
        </Link>

        <div>
          <p className={adultProfile ? 'mb-2 px-1 text-[10px] font-black uppercase tracking-[.12em] text-[#245a9d]' : 'mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500'}>{connectedName}</p>
          <div className="flex flex-col gap-2.5">
            {teamMembers.length === 0 && <p className="rounded-[20px] border border-dashed border-slate-300 bg-white p-5 text-sm text-slate-500">No allied-health professionals or support workers are connected to this participant yet.</p>}
            {teamMembers.map(user => {
              const availableToday = isAvailableOn(user.id, todayISO)
              return (
                <div key={user.id} className={adultProfile ? 'flex items-center gap-3 rounded-[20px] border border-slate-200 bg-white p-3.5 shadow-[0_5px_18px_rgba(15,23,42,.05)]' : 'flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3.5 shadow-card'}>
                  <div className="relative shrink-0"><Avatar user={user} size={44}/>{availableToday && <span className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full border-2 border-white bg-emerald-500"/>}</div>
                  <div className="min-w-0 flex-1"><p className="truncate text-sm font-black text-slate-900">{user.name}</p><p className="truncate text-xs font-semibold text-slate-500">{user.title ?? roleLabels[user.role]}</p>{availableToday && <p className="mt-0.5 text-[10px] font-black text-emerald-600">Available today</p>}</div>
                  <Link to={`/chats/${user.id}`} className={adultProfile ? 'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#edf4ff] text-[#3765b2]' : 'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600'} aria-label={`Message ${user.name}`}>💬</Link>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

